import { MasterLegalAgreementType } from 'api'
import { Selectbox, SelectboxProps } from 'view/components/options'
import { Field } from 'view/components/inputs'
import React from 'react'
import { getEnumValues } from 'model'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { createTradingRelationshipMasterLegalAgreementsSelector } from 'selectors/tradingRelationshipSelectors'

/* MLA All */
export type MasterLegalAgreementTypeSelectboxProps = Omit<SelectboxProps<MasterLegalAgreementType, MasterLegalAgreementType>, 'optionKeys'>

export const MasterLegalAgreementTypeSelectbox = React.forwardRef(
  (props: MasterLegalAgreementTypeSelectboxProps, ref: React.Ref<Selectbox>) => {
    const optionKeys = getEnumValues(MasterLegalAgreementType)
    return <Selectbox ref={ref} optionKeys={optionKeys} {...props} />
  }
)

export const MasterLegalAgreementTypeSelectboxField = Field(MasterLegalAgreementTypeSelectbox)

/* MLA Relationship */

export interface CounterpartyMasterLegalAgreementTypeSelectboxProps
  extends Omit<SelectboxProps<MasterLegalAgreementType, MasterLegalAgreementType>, 'optionKeys' | 'getOption'> {
  fundId?: string | null
  counterpartyIds?: string[] | null
}

const fundIdSelector = (_: {}, props: CounterpartyMasterLegalAgreementTypeSelectboxProps) => props.fundId
const counterpartyIdsSelector = (_: {}, props: CounterpartyMasterLegalAgreementTypeSelectboxProps) => props.counterpartyIds

const counterpartyMapStateToProps = createStructuredSelector({
  optionKeys: createTradingRelationshipMasterLegalAgreementsSelector(fundIdSelector, counterpartyIdsSelector)
})

export const CounterpartyMasterLegalAgreementTypeSelectbox = connect(counterpartyMapStateToProps, null, null, { forwardRef: true })(
  Selectbox as React.ComponentType<CounterpartyMasterLegalAgreementTypeSelectboxProps>
)
